<template>
    <section>
        <div :class="[image ? 'square' : 'ctn diamond-shape']" :style="styleAvatar">
            <img v-if="image"
                :src="image"
                :alt="fullname ? fullname : ''"
                class="pic"
                :style="stylePic"
            >
            <span v-else-if="fullname" class="white--text item" :style="styleIni">{{initials}}</span>
            <span v-else class="white--text item" :style="styleIni">?</span>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            fullname: {
                type: String,
                required: false
            },
            image: {
                type: String,
                required: false
            },
            size: {
                type: [String, Number],
                required: false,
                default: 48
            },
        },
        data () {
            return {}
        },
        computed: {
            styleAvatar(){
                let s = 2/3*this.size*2;
                let m = 1/6*this.size*2;
                let f= 2/3*this.size;
                if(this.image){
                    return 'background-color: white; height: ' + s + 'px; width: ' + s + 'px; margin: ' + m + 'px;';
                } else{
                    return 'height: ' + s + 'px; width: ' + s + 'px; margin: ' + m + 'px; background-image:radial-gradient(' + f + 'px, #589C8F, #37625a);';
                }
            },
            stylePic(){
                let m = 1/6*this.size*2;
                return 'height: ' + this.size*2 + 'px; width: ' + this.size*2 + 'px; margin: -' + m + 'px;';
            },
            styleIni(){
                let s = 2/3*this.size*2;
                let f= 2/3*this.size;
                return 'height: ' + s + 'px; width: ' + s + 'px; font-size: ' + f + 'px !important; font-weight: bold; line-height: 1!important;';
            },
            initials(){
                if(this.fullname && this.fullname != "undefined undefined"){
                    var initials = this.fullname.match(/\b\w/g) || [];
                    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
                    return initials;
                }
                return "";
            }
        },
    }
</script>
<style scoped>
.ctn {
  margin: auto;
  text-align: center;
  width: 940px;
}
.diamond-shape {
  /*background: #589C8F;
  background-image:radial-gradient(10px, #589C8F, #37625a);*/
  text-align: center;
  transform: rotate(45deg);
}
.item {
  display: table-cell;
  transform: rotate(-45deg);
  vertical-align: middle;
}

.square {
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  overflow: hidden;
}
.pic {
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  object-fit: cover;
}
</style>